<template>
    <div>
        <el-upload
          class="formImage"
          multiple
          accept="image/*"
          list-type="picture-card"
          ref="uploadObj"
          :action="action"
          :limit="20"
          :auto-upload="true"
          :show-file-list="showFileList"
          :file-list="fileList"
          :before-upload="beforeImport"
          :on-exceed="handleExceed"
          :on-preview="handleFile"
          :on-success="handleSuccess"
          :on-remove="handleRemove">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}">
            <img
                class="el-upload-list__item-thumbnail"
                :title="file.fileName"
                :src="file.url" alt=""
            >
            <span class="el-upload-list__item-actions">
                <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                    >
                    <i class="el-icon-zoom-in"></i>
                </span>
                <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleFile(file)"
                    >
                    <i class="el-icon-download"></i>
                </span>
                <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                    >
                    <i class="el-icon-delete"></i>
                </span>
            </span>
            </div>
        </el-upload>
        <el-dialog 
            append-to-body
            top="3vh"
            width="95%"
            :visible.sync="dialogVisible">
            <div width="100%" style="text-align:center;">
            <img :src="dialogImageUrl" alt="" style="max-height:100%;max-width:100%;">
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { API_FILE_UPLOAD, API_FILE_DOWNLOAD } from '@/common/constants';
    import { downloadFiles } from '@/data-model';
    export default {
        data () {
            return {
                uploadFiles: [],
                dialogImageUrl: '',
                dialogVisible: false,
                disabled: false
            };
        },
        watch: {
        },
        props: {
            fileType: { // 文件上传组件的类型。1:普通文件；2:图片，支持图片预览
                type: Number,
                default: 2
            },
            fileList: {
                type: Array
            },
            showFileList: {
                type: Boolean,
                default: true
            },
            isShowUploadBtn: {
                type: Boolean,
                default: true
            },
            action: {
                type: String,
                default: API_FILE_UPLOAD
            },
            btnContent: {
                type: String,
                default: '一次上传的图片大小总量不超过350M'
            },
            isRead: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            /** 清理已经上传的文件 */
            _clearUploadFiles () {
                this.$refs.uploadObj.clearFiles();
            },
            handleSuccess (response, file, fileList) {
                // console.log({ response, file, fileList });
                let isFinish = true;
                for (const index in fileList) {
                    if (fileList[index].status !== 'success') {
                        isFinish = false;
                        break;
                    }
                }
                // 如果没有全部上传完成，忽略本次上次回调
                if (!isFinish) {
                    return;
                }
                this.$emit('success', { response, file, fileList });
            },
            handleRemove (file) {
                let delIndex = -1;
                for (const index in this.fileList) {
                    if (this.fileList[index].uid === file.uid) {
                        delIndex = index;
                        break;
                    }
                }
                this.fileList.splice(delIndex, 1);
                let param = {
                    file: file,
                    fileList: this.fileList
                };
                this.$emit('remove', param);
            },
            handleFile (file) {
                let url = `${API_FILE_DOWNLOAD}${file.filePath}`;
                this.download(url);
            },
            handleExceed (files, fileList) {
                this.$message.warning(`每次上传限制10张图片，本次选择了 ${files.length} 张图片，共选择了 ${files.length + fileList.length} 张图片`);
            },
            download (url) {
                downloadFiles(url);
                // var iframe = document.createElement('iframe');
                // iframe.style.display = 'none';
                // iframe.src = url;
                // document.body.appendChild(iframe);
            },
            handlePreviewFile (file) {
                this.$emit('previewFile', file);
            },
            beforeImport (file) {
                let isLt350M = (file.size / 1024 / 1024 < 1024);
                if (!isLt350M) {
                    this.$message.error('上传图片大小不能超过 1000MB!');
                    return false;
                }
                return true;
            },
            handlePictureCardPreview (file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            }
        }
    };
</script>

<style lang="less">
    .formImage{
        .el-upload-list__item{
            width: 90px;
            height: 90px;
            .el-upload-list__item-{
                &preview{
                    font-size: 15px;
                }
                &delete{
                    font-size: 15px;
                }
            }
        }
        .el-upload--picture-card{
            width: 90px;
            height: 90px;
            line-height: 100px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ImageUpload/ImageUpload.vue